import Unit from '@/models/Unit';
import { CourseRoute } from '@/utils/routes';
import StaffUnitLessons from './StaffUnitLessons';
import UnitSection from './UnitSection';
import UnitShortcuts from './UnitShortcuts';

type StaffUnitSectionProps = CourseRoute & {
  unit: Unit;
  defaultOpen: boolean;
};

export default function StaffUnitSection({
  unit,
  defaultOpen,
  ...route
}: StaffUnitSectionProps) {
  return (
    <UnitSection
      unit={unit}
      defaultOpen={defaultOpen}
      classNames={{ card: 'bg-base-100' }}
      shortcuts={
        unit.contentLesson && (
          <UnitShortcuts contentLesson={unit.contentLesson} {...route} />
        )
      }
    >
      <StaffUnitLessons unitId={unit.id} {...route} />
    </UnitSection>
  );
}
